/**
 * AcademyAdminPanel — Panneau d'administration des pré-inscriptions Académie SAFUAYE.
 * Extrait du monolithe App.js. Aucune règle métier n'a été modifiée.
 */
export const AcademyAdminPanel = ({
  adminAcademyRecs, acadCount,
  fetchAdminAcademy, deleteAcademyRec,
}) => {
  const exportCSV = () => {
    if (!adminAcademyRecs.length) { alert("Aucune pré-inscription à exporter"); return; }
    const headers = ["child_name", "child_age", "category", "school", "village", "parent_name", "parent_contact", "parent_email", "consent_data", "consent_photo", "notes", "created_at"];
    const escape = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const rows = [headers.join(",")].concat(
      adminAcademyRecs.map(r => headers.map(h => escape(r[h])).join(","))
    );
    const csv = rows.join("\n");
    const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    const dt = new Date().toISOString().slice(0, 10);
    a.href = url;
    a.download = `safuaye_academy_preregistrations_${dt}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-academy-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <h3 className="font-heading text-xl font-bold text-gray-900 flex items-center gap-2">
          ⚽ Pré-inscriptions Académie SAFUAYE
        </h3>
        <div className="flex gap-2">
          <button
            onClick={fetchAdminAcademy}
            className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 px-3 py-2 rounded font-semibold"
            data-testid="admin-academy-refresh"
          >
            🔄 Rafraîchir
          </button>
          <button
            onClick={exportCSV}
            className="text-xs bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded font-semibold"
            data-testid="admin-academy-export-csv"
          >
            ⬇️ Export CSV
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-4">
        <div className="bg-gradient-to-br from-slate-50 to-slate-100 border border-slate-200 rounded-lg p-3">
          <p className="text-xs text-slate-600 uppercase font-semibold">Total</p>
          <p className="text-2xl font-bold text-slate-900">{acadCount.total}</p>
        </div>
        {["U7", "U9", "U11", "U13"].map((cat) => (
          <div key={cat} className="bg-gradient-to-br from-orange-50 to-red-50 border border-orange-200 rounded-lg p-3">
            <p className="text-xs text-orange-700 uppercase font-semibold">{cat}</p>
            <p className="text-2xl font-bold text-orange-900">{acadCount.by_category[cat] || 0}</p>
          </div>
        ))}
      </div>

      {adminAcademyRecs.length === 0 ? (
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 text-center">
          <p className="text-gray-500 text-sm">Aucune pré-inscription pour l&apos;instant.</p>
          <p className="text-gray-400 text-xs mt-1">Partagez le lien <code className="bg-white px-1.5 py-0.5 rounded border">safuaye.org#academy</code> sur WhatsApp diaspora &amp; Facebook pour lancer les pré-inscriptions.</p>
        </div>
      ) : (
        <div className="overflow-x-auto bg-white rounded-xl shadow border border-gray-200">
          <table className="w-full text-sm" data-testid="admin-academy-table">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Enfant</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Âge</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Cat.</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">École</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Village</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Parent</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Contact</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Photo</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Date</th>
                <th className="text-left px-3 py-2 text-xs font-semibold text-gray-700 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody>
              {adminAcademyRecs.map((r) => (
                <tr key={r.id} className="border-b border-gray-100 hover:bg-gray-50">
                  <td className="px-3 py-2 font-medium text-gray-900">{r.child_name}</td>
                  <td className="px-3 py-2 text-gray-600">{r.child_age}</td>
                  <td className="px-3 py-2">
                    <span className="inline-block px-2 py-0.5 rounded text-xs font-semibold bg-orange-100 text-orange-800">{r.category}</span>
                  </td>
                  <td className="px-3 py-2 text-gray-600">{r.school || "—"}</td>
                  <td className="px-3 py-2 text-gray-600">{r.village || "—"}</td>
                  <td className="px-3 py-2 text-gray-600">{r.parent_name}</td>
                  <td className="px-3 py-2 text-gray-600 whitespace-nowrap">
                    <div className="flex flex-col">
                      <span>{r.parent_contact}</span>
                      {r.parent_email && <span className="text-xs text-gray-400">{r.parent_email}</span>}
                    </div>
                  </td>
                  <td className="px-3 py-2 text-center">{r.consent_photo ? "✅" : "—"}</td>
                  <td className="px-3 py-2 text-xs text-gray-500 whitespace-nowrap">{r.created_at ? new Date(r.created_at).toLocaleDateString('fr-FR') : "—"}</td>
                  <td className="px-3 py-2">
                    <button
                      onClick={() => deleteAcademyRec(r.id)}
                      className="text-xs bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded font-semibold"
                      data-testid={`admin-academy-delete-${r.id}`}
                    >
                      🗑️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <div className="mt-4 bg-orange-50 border-l-4 border-orange-500 p-3 rounded text-xs text-orange-900">
        🎯 <strong>Prochaine étape :</strong> partagez le lien <code className="bg-white px-1.5 py-0.5 rounded border">safuaye.org#academy</code> sur WhatsApp diaspora + Facebook + auprès des directeurs d&apos;écoles ciblées. Les parents pourront pré-inscrire leurs enfants en 5 minutes. Confirmation définitive lors du Gala du 30 août 2026.
      </div>
    </div>
  );
};

export default AcademyAdminPanel;
